module.exports = __webpack_public_path__ + "fonts/BebasNeueCyrillyc.ttf?e8b9350be099a2096e4438a327e88cc5";